import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import about from "../images/slide1.png";
import { Fade } from "react-reveal";

const AboutSection = () => {
  return (
    <Box sx={{ py: 5, maxWidth: "1200px", margin: "0 auto", px: { xs: 2, sm: 0 } }}>
      <Grid container spacing={4} alignItems="center">
        {/* Left Column (Text) */}
        <Grid item xs={12} md={7}>
          <Fade left>
            <Typography
              variant="h4"
              sx={{
                fontSize: {
                  xs: "1.5rem", 
                  sm: "2rem", md: "2.5rem"  
                },
                fontWeight: "bold",
                mb: 4
              }}
            >
              Your Journey to Financial Confidence Starts with Finkoda
            </Typography>

            <Typography variant="body1" sx={{ mb: 4 }}>
              Welcome to Finkoda, where financial simplicity meets your needs every day. Our platform is designed to provide you with personalized solutions, expert advice, and a community to support your financial goals. Finkoda – Your Personalized Path to Financial Confidence.
            </Typography>
          </Fade>
        </Grid>

        {/* Right Column (Image) */}
        <Grid item xs={12} md={5}>
          <Fade right>
            <Box
              component="img"
              src={about}
              alt="Feature Background"
              sx={{ maxWidth: "100%", width: 550, px: { xs: 0 } }}
            />
          </Fade>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutSection;
